import React from "react";
import {runtime} from "@codeArt/common";
import {type, invalid} from "@codeArt/utils/common";

import _ from "lodash";

export function getColumns(l){
  return l.filter(t => t);
}

export function getColumnField(c){
  return c.field || c.id || c.Id;
}

export function getFixedWidth(columns){
  if (!columns) return 0;
  //获得列表固定宽度
  if (runtime.pc) {
    //目前计算宽度仅支持桌面端，手机端该方法没有实际用途
    let total = 0;
    for (let i = 0; i < columns.length; i++) {
      let {width} = columns[i];
      if (invalid(width)) return; //有无效的宽度，说明是动态列
      if (_.isInteger(width) || width.endsWith("px")) {
        total += parseInt(width);
        continue;
      }
      return; //其余的情况都是动态列，列表没有固定宽度
    }
    return total;
  }
}
